export const version = "networks/5.2.0";
//# sourceMappingURL=_version.js.map